/**
 * French messages of the offline layer: the sticky banner and the rejects
 * sheet (`docs/OFFLINE.md` §2). Merged into the catalogue by `src/i18n/fr.ts`
 * under the `offline` key.
 */
export const offlineMessages = {
  banner: {
    offline: 'Hors ligne',
    offlineWithPending: 'Hors ligne · {{count}} visite{{plural}} en attente',
    sending: 'Envoi… {{count}} restante{{plural}}',
    rejectedOnly: '{{count}} porte{{plural}} refusée{{plural}} à vérifier',
    reviewLink: 'Voir les refus ({{count}})',
  },
  sheet: {
    title: 'Portes refusées',
    empty: 'Aucun refus pour le moment.',
    kind: {
      visit: 'Visite',
      registration: "Dossier d'inscription",
      engagement: 'Engagement',
      other: 'Écriture',
    },
    noteLabel: 'Note à recopier',
    remove: 'Retirer',
  },
  rejected: {
    doorAlreadyRecorded:
      'Cette porte a été renseignée par quelqu’un d’autre pendant que vous étiez hors ligne.',
    doorHeldByOther: 'Cette porte est désormais détenue par quelqu’un d’autre.',
    invalidVisit: "Cet enregistrement n'est plus valide.",
    consentRequired: 'Le consentement est obligatoire.',
    other: "L'envoi a été refusé.",
  },
} as const;
